/** @jsxRuntime classic */
/** @jsx jsx */
import {
  Alert,
  AlertDescription,
  Box,
  Button,
  Center,
  Flex,
  Image,
  Text,
} from '@chakra-ui/react';
import { css, jsx } from '@emotion/react';
import axios from 'axios';
import React, { useEffect, useState } from 'react';
import toast, { Toaster } from 'react-hot-toast';
import { MdDelete, MdUpdate } from 'react-icons/md';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useParams } from 'react-router-dom';
import {
  DoNotShowWrite,
  selectLogin,
  selectUser,
} from '../redux/loginSlice.js';
import Background from './cafe.jpg';
import Footer from './layout/Footer';
import Header from './layout/HeaderB';

const ReviewsList = () => {
  const [reviews, setReviews] = useState([]);
  const { id } = useParams();
  const User = useSelector(selectUser);
  const View = useSelector(selectLogin);
  const dispatch = useDispatch();

  useEffect(() => {
    const getReviews = async () => {
      const response = await axios.get(
        'https://mern-stack-restaurants-app.herokuapp.com/reviews/' + id
      );
      setReviews(response.data);
    };
    getReviews();
  }, [id]);

  function deleteReview(id) {
    axios
      .delete('/reviews/' + id)
      .then(response => {
        const notify = () => toast.success('Review deleted');
        notify();
        setReviews(reviews.filter(review => review.id !== id));
      })
      .catch(response => {
        console.log('An error occurred', response.data);
        const notify = () => toast.error('Could not delete review');
        notify();
      });
  }

  return (
    <React.Fragment>
      <Box
        css={{
          minHeight: 'calc(100vh - 80px)',
          backgroundImage: 'url(' + Background + ')',
          backgroundSize: 'cover',
          marginBottom: '-5px',
        }}
      >
        <Header />
        <Toaster />
        {View === 'Login' && (
          <Flex direction="row" wrap="wrap" justify="center">
            <Button
              css={css`
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
                @media (max-width: 350px) {
                  font-size: 13px;
                }
              `}
              mt={3}
              mb={8}
              ml={5}
              colorScheme="blue"
              onClick={e => {
                window.location.reload();
                dispatch(DoNotShowWrite());
              }}
            >
              Refresh page and logout
            </Button>
          </Flex>
        )}
        {View === 'Logout' && (
          <>
            <Center>
              <Alert bg="#f9bf3b" color="#000" w={500}>
                <AlertDescription px={1} py={1}>
                  To be able to update and delete a review you have to register
                  and login
                </AlertDescription>
              </Alert>
            </Center>
            <Center>
              <Button
                css={css`
                  @media (max-width: 350px) {
                    font-size: 13px;
                  }
                `}
                colorScheme="blue"
                my={5}
              >
                <Link to={`/auth`} style={{ color: '#fff' }}>
                  Register and Login
                </Link>
              </Button>
            </Center>
          </>
        )}
        <Flex direction="row" wrap="wrap" justify="center">
          {reviews &&
            reviews.map((review, index) => {
              return (
                <Flex
                  key={index}
                  direction="column"
                  align="center"
                  justify="start"
                  textAlign="center"
                  w="300px"
                  border="2px solid #000"
                  py={3}
                  mx={5}
                  mb={10}
                  bg="#e8ecf1"
                  overflow="hidden"
                >
                  <Box>
                    <Text fontSize="xl" fontWeight="700" color="#000">
                      {review.title}
                    </Text>
                    <Text fontSize="lg" color="#000" px={10} as="i">
                      {review.desc}
                    </Text>
                    <Text fontSize="lg">Score: {review.score}</Text>
                    <Image
                      src={review.picture}
                      alt="Real image"
                      borderRadius="full"
                      boxSize="250px"
                      mx="auto"
                    />
                    <span
                      css={css`
                        margin-top: 15px;
                      `}
                      className="columnButtons"
                    >
                      <Button
                        disabled={review.username !== User}
                        onClick={() => {
                          deleteReview(review._id);
                        }}
                        css={css`
                          font-weight: bold;
                          @media (max-width: 350px) {
                            font-size: 14px;
                            height: 55px;
                          }
                        `}
                        bg="#d91e18"
                      >
                        <MdDelete /> Delete
                      </Button>
                      <Button
                        disabled={review.username !== User}
                        css={css`
                          margin-left: 10px;
                          @media (max-width: 350px) {
                            font-size: 14px;
                            height: 55px;
                          }
                        `}
                        bg="#f9b42d"
                      >
                        <Link
                          to={'/update/' + review._id}
                          css={css`
                            font-weight: bold;
                            color: #000;
                          `}
                        >
                          <MdUpdate /> Update
                        </Link>
                      </Button>
                    </span>
                  </Box>
                </Flex>
              );
            })}
        </Flex>
      </Box>
      <Footer />
    </React.Fragment>
  );
};

export default ReviewsList;
